/** Parent of a folder path, or null when the folder sits at the project root. */
export const parentFolderPath = (folderPath: string): string | null => {
  const segments = folderPath.split('/')
  return segments.length > 1 ? segments.slice(0, -1).join('/') : null
}
